import { render, staticRenderFns } from "./DownloadAndView.vue?vue&type=template&id=77c0414a&"
import script from "./DownloadAndView.vue?vue&type=script&lang=js&"
export * from "./DownloadAndView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports